import defaultsDeep from "lodash/defaultsDeep";
import assetFont from "./tokens/asset/font.json";
import color from "./tokens/color.json";
import font from "./tokens/font.json";
import helpersShadows from "./tokens/helpers/shadows.json";
import helpersSkeleton from "./tokens/helpers/skeleton.json";
import shadow from "./tokens/shadow.json";
import sizeFont from "./tokens/size/font.json";
import sizeRadius from "./tokens/size/radius.json";
import sizeSpacing from "./tokens/size/spacing.json";
import textTransform from "./tokens/text/transform.json";
export const defaultTokens = defaultsDeep({}, assetFont, color, font, helpersShadows, helpersSkeleton, sizeRadius, shadow, sizeFont, sizeSpacing, textTransform);
